<configurator-header></configurator-header>

<!--one3d-summary-panel-wrapper starts here-->
<ion-content
  scrollY="false"
  [ngClass]="{ 'height-for-safari': applyHeightForCompatibility }"
  class="one3d-summary-panel-wrapper"
>
  <div class="one3d-summary-wrapper">
    <div class="one3d-content-header one3d-custom-border-bottom">
      <h1 class="one3d-content-header-title" translate>SUMMARY.SUMMARY</h1>
      <button (click)="closeSummary()">
        <span
          ><img
            src="assets/img/icons/one3d-close-icon.svg"
            alt="close page icon"
        /></span>
      </button>
    </div>
    <div
      class="one3d-scrollable-wrapper-custom one3d-scrollable-wrapper-custom-remove-bottom-space"
    >
      <summary-breakup></summary-breakup>
      <div class="one3d-offer-listing-border"></div>
      <ion-accordion-group
        class="one3d-view-added-accessories-accordion"
        #summaryAccordion
        value="addOffers"
      >
        <ion-accordion
          *ngIf="globalService.show_offer === 'yes'"
          value="addOffers"
          (click)="toggleAccordionClick('addOffers', 0)"
        >
          <ion-item
            class="one3d-accordion-item"
            slot="header"
            [ngClass]="{
              'one3d-accordion-item-selected':
                summaryAccordion?.value === 'addOffers'
            }"
          >
            <ion-label class="one3d-accordion-label">
              <h4 class="one3d-accordion-variant-label" translate>
                VIEW OFFERS
              </h4>
            </ion-label>
          </ion-item>
          <div
            class="one3d-bottom-padding-0 one3d-offer-listing"
            slot="content"
          >
            <ul>
              <li *ngFor="let offer of offers.offerData">
                <div class="inner">
                  <div class="one3d-offer-h1">{{ offer.offer_for }}</div>
                  <div class="one3d-offer-h2">{{ offer.title }}</div>
                  <div
                    class="one3d-offer-h3"
                    [innerHTML]="offer.description"
                  ></div>
                  <div class="one3d-offer-h4">
                    <i
                      [innerHTML]="
                        offer.showMore
                          ? getSanitizedDynamicText(offer?.disclaimer)
                          : (getSanitizedDynamicText(offer?.disclaimer)
                            | slice : 0 : 250)
                      "
                    ></i>
                    <span
                      *ngIf="offer?.disclaimer?.length > 55"
                      (click)="offer.showMore = !offer.showMore"
                    >
                      {{ offer.showMore ? "Show less" : "Show More" }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </ion-accordion>

        <ion-accordion
          value="addedAcc"
          (click)="toggleAccordionClick('addedAcc', 0)"
        >
          <ion-item
            class="one3d-accordion-item"
            slot="header"
            [ngClass]="{
              'one3d-accordion-item-selected':
                summaryAccordion?.value === 'addedAcc'
            }"
          >
            <ion-label class="one3d-accordion-label">
              <h4 class="one3d-accordion-variant-label" translate>
                SUMMARY.VIEW_ADDED_ACCESSORIES
              </h4>
            </ion-label>
          </ion-item>
          <div class="one3d-bottom-padding-0" slot="content">
            <div class="one3d-view-added-accessories-box-wrap">
              <div
                [ngClass]="{
                  'one3d-custom-border-bottom': accessories.length > 0,
                  'one3d-summary-ext-int-wrapper': accessories.length > 0
                }"
              >
                <div
                  *ngFor="let accessory of accessories"
                  class="one3d-summary-ext-int one3d-summary-ext one3d-summary-row-margin"
                >
                  <h2
                    class="one3d-summary-sub-title eone3d-summary-ext-int-title"
                  >
                    {{ accessory.groupName | uppercase }}
                    {{ "SUMMARY.ACCESSORIES" | translate }}
                  </h2>
                  <ion-row *ngFor="let item of accessory.accessories">
                    <ion-col size="6">
                      <span class="one3d-summary-item-name">
                        {{ item.marketing_name }}
                      </span>
                    </ion-col>
                    <ion-col size="6">
                      <div class="one3d-summary-content-right-col">
                        <span class="one3d-summary-item-value">
                          {{ globalService.currencyFormatter(item.price) }}
                        </span>
                        <ion-icon
                          (click)="
                            removeAccessoryConfirmation(
                              item,
                              accessory.groupName
                            )
                          "
                          class="one3d-delete-icon one3d-summary-delete-icon"
                          name="trash-outline"
                        ></ion-icon>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
              <div *ngIf="accessories.length == 0" class="one3d-summary-no-acc">
                <h4 class="one3d-summary-no-acc-title" translate>
                  SUMMARY.NO_ACCESSORY_ADDED
                </h4>
                <p class="one3d-summary-no-acc-para" translate>
                  SUMMARY.NO_ACCESSORIES
                </p>
                <button
                  (click)="closeAndOpenAccessories()"
                  class="one3d-summary-no-acc-btn"
                  translate
                >
                  SUMMARY.ACCESSORISE_NOW
                </button>
              </div>
            </div>
          </div>
        </ion-accordion>

        <ion-accordion
          value="nearestDealer"
          (click)="toggleAccordionClick('nearestDealer', 0)"
        >
          <ion-item
            class="one3d-accordion-item"
            slot="header"
            [ngClass]="{
              'one3d-accordion-item-selected':
                summaryAccordion?.value === 'nearestDealer'
            }"
          >
            <ion-label class="one3d-accordion-label">
              <h4 class="one3d-accordion-variant-label" translate>
                YOUR NEAREST DEALER
              </h4>
            </ion-label>
          </ion-item>

          <div
            class="one3d-bottom-padding-0 one3d-dealer-opening-hours"
            slot="content"
          >
            <div class="one3d-dealer-block">
              <div class="one3d-dealer-row one3d-dealer-row1">
                <div class="one3d-dealer-title">
                  <div class="one3d-dealer-title-icon">
                    <img src="assets/img/icons/dealer-icon.svg" alt="icon" />
                  </div>
                  <div class="one3d-dealer-title-info">
                    {{ nearestDealer?.name }}
                  </div>
                </div>
              </div>
              <div class="one3d-dealer-row one3d-dealer-row1">
                <b>ADDRESS</b>
                <address>
                  {{ nearestDealer?.address.line1 }},
                  {{ nearestDealer?.address.city }},
                  {{ nearestDealer?.address.state }}
                  {{ nearestDealer?.address.postal_code }}
                </address>
              </div>
              <div class="one3d-dealer-row one3d-dealer-row1">
                <b>PHONE</b>
                <p>{{ nearestDealer?.phone }}</p>
              </div>
              <div class="one3d-dealer-row">
                <b>OPENING HOURS</b>
                <ul>
                  <li *ngFor="let day of getOpeningHoursKeys()">
                    <div class="one3d-dealer-left">{{ day }}</div>
                    <div class="one3d-dealer-right">
                      {{ nearestDealer?.week[day] }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <!--one3d-view-added-accessories-emi starts here-->
      <div class="one3d-view-added-accessories-emi">
        <div value="variant">
          <div class="one3d-bottom-padding-0" slot="content">
            <div
              *ngIf="emiDetails"
              class="one3d-view-added-accessories-box-wrap"
            >
              <ion-row class="one3d-view-added-accessories-row-header">
                <ion-col size="6">
                  <h4 class="one3d-added-accessories-heading" translate>
                    SUMMARY.EMI
                  </h4>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <div class="one3d-edit-remove-btn-wrapper ion-text-right">
                    <ion-button
                      (click)="showEmiCalculator()"
                      class="one3d-edit-remove-btn one3d-edit-btn"
                      color="dark"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.EDIT
                    </ion-button>
                    <ion-button
                      (click)="removeBtn('emi_details', 'EMI')"
                      class="one3d-edit-remove-btn one3d-remove-btn"
                      color="danger"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.REMOVE
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.DOWN_PAYMENT
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{
                      emiDetails.DownPayment > 0
                        ? globalService.currencyFormatter(
                            emiDetails.DownPayment
                          )
                        : emiDetails.DownPayment
                    }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.TENURE
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ emiDetails.TermDuration }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.ANNUAL_PERCENTAGE_RATE
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ emiDetails.AnnualPercentageRate }} %
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    <strong translate> SUMMARY.MONTHLY_EMI </strong>
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    <strong>
                      {{
                        globalService.currencyFormatter(
                          emiDetails.EstimatedMonthlyPayment
                        )
                      }}
                    </strong>
                  </span>
                </ion-col>
              </ion-row>
            </div>
            <div
              *ngIf="carExchange"
              class="one3d-view-added-accessories-box-wrap"
            >
              <ion-row class="one3d-view-added-accessories-row-header">
                <ion-col size="6">
                  <h4 class="one3d-added-accessories-heading" translate>
                    SUMMARY.TRADE_IN
                  </h4>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <div class="one3d-edit-remove-btn-wrapper ion-text-right">
                    <ion-button
                      class="one3d-edit-remove-btn one3d-edit-btn"
                      color="dark"
                      shape="round"
                      fill="outline"
                      (click)="showCarExchange()"
                      translate
                    >
                      SUMMARY.EDIT
                    </ion-button>
                    <ion-button
                      class="one3d-edit-remove-btn one3d-remove-btn"
                      color="danger"
                      shape="round"
                      fill="outline"
                      (click)="removeBtn('exchange_values', 'TRADE-IN')"
                      translate
                    >
                      SUMMARY.REMOVE
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.MODEL
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ carExchange.MakeBrand }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.VARIANT
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ carExchange.MakeVariant }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.YEAR
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ carExchange.MakeYear }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    <strong translate>
                      SUMMARY.APPROXIMATE_EXCHANGE_VALUE
                    </strong>
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    <strong>
                      {{
                        globalService.currencyFormatter(
                          carExchange.MinimumValue
                        )
                      }}</strong
                    >
                  </span>
                </ion-col>
              </ion-row>
            </div>
            <div
              *ngIf="extendedWarrantyDetails"
              class="one3d-view-added-accessories-box-wrap"
            >
              <ion-row class="one3d-view-added-accessories-row-header">
                <ion-col size="6">
                  <h4 class="one3d-added-accessories-heading" translate>
                    SUMMARY.EXTENDED_WARRANTY
                  </h4>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <div class="one3d-edit-remove-btn-wrapper ion-text-right">
                    <ion-button
                      (click)="showExtendedWarranty()"
                      class="one3d-edit-remove-btn one3d-edit-btn"
                      color="dark"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.EDIT
                    </ion-button>
                    <ion-button
                      (click)="
                        removeBtn(
                          'extendedWarranty_details',
                          'EXTENDED WARRANTY'
                        )
                      "
                      class="one3d-edit-remove-btn one3d-remove-btn"
                      color="danger"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.REMOVE
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.DURATION
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ extendedWarrantyDetails.vehicleAge }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.MILEAGE
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ extendedWarrantyDetails.mileage }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    <strong translate> SUMMARY.WARRANTY_COST </strong>
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    <strong>
                      {{
                        globalService.currencyFormatter(
                          extendedWarrantyDetails.warrantyPrice
                        )
                      }}
                    </strong>
                  </span>
                </ion-col>
              </ion-row>
            </div>
            <div
              class="one3d-view-added-accessories-box-wrap"
              *ngIf="insuranceDetails"
            >
              <ion-row class="one3d-view-added-accessories-row-header">
                <ion-col size="6">
                  <h4 class="one3d-added-accessories-heading" translate>
                    SUMMARY.INSURANCE
                  </h4>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <div class="one3d-edit-remove-btn-wrapper ion-text-right">
                    <ion-button
                      (click)="showInsurance()"
                      class="one3d-edit-remove-btn one3d-edit-btn"
                      color="dark"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.EDIT
                    </ion-button>
                    <ion-button
                      (click)="removeBtn('insurancePlan_details', 'INSURANCE')"
                      class="one3d-edit-remove-btn one3d-remove-btn"
                      color="danger"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.REMOVE
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
              <!-- <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    Insurance Provider
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ insuranceDetails.insuranceProvider }}
                  </span>
                </ion-col>
              </ion-row> -->
              <!-- <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    Insurance Premium</span
                  >
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    
                    {{
                      globalService.currencyFormatter(
                        insuranceDetails.insurancePremium
                      )
                    }}
                  </span>
                </ion-col>
              </ion-row> -->
              <!-- <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    Package (addons) amount</span
                  >
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    
                    {{
                      globalService.currencyFormatter(
                        insuranceDetails.packageAddonsAmount
                      )
                    }}
                  </span>
                </ion-col>
              </ion-row> -->
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    <strong translate> SUMMARY.INSURANCE_COST</strong>
                    <h1>sdasd</h1>
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    <strong>
                      {{
                        globalService.currencyFormatter(
                          insuranceDetails.insuranceCost
                        )
                      }}
                    </strong>
                  </span>
                </ion-col>
              </ion-row>
            </div>
            <div
              *ngIf="mspDetails"
              class="one3d-view-added-accessories-box-wrap"
            >
              <ion-row class="one3d-view-added-accessories-row-header">
                <ion-col size="7">
                  <h4 class="one3d-added-accessories-heading" translate>
                    SUMMARY.MAINTENANCE_SERVICE_PLAN
                  </h4>
                </ion-col>
                <ion-col size="5" class="one3d-summary-content-right-col">
                  <div class="one3d-edit-remove-btn-wrapper ion-text-right">
                    <ion-button
                      (click)="showAmcCalculator()"
                      class="one3d-edit-remove-btn one3d-edit-btn"
                      color="dark"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      SUMMARY.EDIT
                    </ion-button>
                    <ion-button
                      (click)="removeBtn('amc_details', 'MSP')"
                      class="one3d-edit-remove-btn one3d-remove-btn"
                      color="danger"
                      shape="round"
                      fill="outline"
                      translate
                    >
                      INSURANCE_COST.REMOVE
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.DURATION
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ mspDetails.product_year }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name" translate>
                    SUMMARY.MILEAGE
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    {{ mspDetails.product_kms }}
                  </span>
                </ion-col>
              </ion-row>
              <ion-row class="one3d-view-added-accessories-row">
                <ion-col size="6">
                  <span class="one3d-summary-descriptor-name">
                    <strong translate> SUMMARY.MSP_COST </strong>
                  </span>
                </ion-col>
                <ion-col size="6" class="one3d-summary-content-right-col">
                  <span class="one3d-summary-descriptor-value">
                    <strong>
                      {{
                        globalService.currencyFormatter(
                          mspDetails.AnnualMaintenanceContractPrice
                        )
                      }}
                    </strong>
                  </span>
                </ion-col>
              </ion-row>
            </div>
          </div>
        </div>
      </div>
      <!--one3d-view-added-accessories-emi ends here-->

      <div class="one3d-explore-finance-option" *ngIf="enableFinanceOptions">
        <ion-text>
          <h4 translate>SUMMARY.EXPLORE_FINANCE_OPTIONS</h4>
        </ion-text>
        <ion-row class="one3d-explore-finance-option-row ion-text-center">
          <ion-col
            size-xl="12"
            size-lg="12"
            size-md="12"
            size="12"
            class="one3d-explore-finance-option-col"
          >
            <ion-button
              (click)="showEmiCalculator()"
              class="one3d-explore-finance-option-btn"
              color="dark"
              shape="round"
              fill="outline"
            >
              <img
                src="assets/img/icons/one3d-calculator-icon.svg"
                alt="Calculator   Icon"
              />
              {{ "SUMMARY.EMI_CALCULATOR" | translate }}
            </ion-button>
          </ion-col>
          <!-- <ion-col
            size-xl="12"
            size-lg="12"
            size-md="12"
            size="12"
            class="one3d-explore-finance-option-col"
          >
            <ion-button
              (click)="showAusOffers()"
              class="one3d-explore-finance-option-btn"
              color="dark"
              shape="round"
              fill="outline"
            >
              <img
                src="assets/img/icons/one3d-calculator-icon.svg"
                alt="Calculator   Icon"
              />
              {{ "SUMMARY.VIEW_OFFERS" | translate }}
            </ion-button>
          </ion-col> -->
          <!-- <ion-col
            size-xl="6"
            size-lg="6"
            size-md="6"
            size="6"
            class="one3d-explore-finance-option-col"
          >
            <ion-button
              (click)="showCarExchange()"
              class="one3d-explore-finance-option-btn"
              color="dark"
              shape="round"
              fill="outline"
            >
              <img
                src="assets/img/icons/one3d-car-exchange-icon.svg"
                alt="Car Exchange Icon"
              />
              {{'SUMMARY.TRADE_IN_CALCULATOR' | translate}}
            </ion-button>
          </ion-col>
          <ion-col
            size-xl="12"
            size-lg="12"
            size-md="12"
            size="12"
            class="one3d-explore-finance-option-col"
          >
            <ion-button
              (click)="showExtendedWarranty()"
              class="one3d-explore-finance-option-btn one3d-explore-finance-extended"
              color="dark"
              shape="round"
              fill="outline"
            >
              <img
                src="assets/img/icons/one3d-extended-warranty-icon.svg"
                alt="Extended Warranty Icon"
              />
              {{'SUMMARY.EXTENDED_WARANTY' | translate}}
            </ion-button>
          </ion-col>
          <ion-col
            size-xl="12"
            size-lg="12"
            size-md="12"
            size="12"
            class="one3d-explore-finance-option-col"
          >
            <ion-button
              (click)="showAmcCalculator()"
              class="one3d-explore-finance-option-btn one3d-explore-finance-extended"
              color="dark"
              shape="round"
              fill="outline"
            >
              <img
                src="assets/img/icons/one3d-maintenance-service-plan.svg"
                alt="Extended Warranty Icon"
              />
              {{'SUMMARY.MAINTENANCE_SERVICE_PLAN' | translate}}
            </ion-button>
          </ion-col>
          <ion-col
            size-xl="12"
            size-lg="12"
            size-md="12"
            size="12"
            class="one3d-explore-finance-option-col"
          >
            <ion-button
              (click)="showInsurance()"
              class="one3d-explore-finance-option-btn one3d-explore-finance-extended"
              color="dark"
              shape="round"
              fill="outline"
            >
              <img src="assets/img/icons/one3d-insurance.svg" alt="Insurance" />
              {{'SUMMARY.INSURANCE' | translate}}
              
            </ion-button>
          </ion-col> -->
        </ion-row>
      </div>
    </div>
  </div>
  <div class="one3d-lhs-config-bottom-wrapper one3d-placeAtBottom-summary">
    <ion-row class="one3d-lhs-config-btn-row">
      <!-- <ion-col class="ion-no-padding" size="6">
        <ion-button
          class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
          expand="full"
          fill="solid"
          (click)="saveConfiguration()"
        >
          {{ "SUMMARY.SAVE_SHARE" | translate }}
          <span>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span>
        </ion-button>
      </ion-col> -->
      <ion-col class="ion-no-padding" size="12">
        <ion-button
          class="one3d-lhs-config-btn one3d-lhs-config-right-btn one3d-test-drive-button-mobile-only"
          expand="full"
          (click)="testDrive()"
        >
          {{ "SUMMARY.REQUEST_TEST_DRIVE" | translate }}
          <span>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span>
        </ion-button>
        <!-- <ion-button
          class="one3d-lhs-config-btn one3d-lhs-config-right-btn one3d-test-drive-button-mobile-only"
          expand="full"
          *ngIf="globalService.model?.lms_integrated_code === 'JJ24'"
          (click)="reserveVehicle()"
        >
          RESERVE YOUR VEHICLE
          <span>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span>
        </ion-button> -->
      </ion-col>
    </ion-row>
  </div>
</ion-content>
<!--one3d-summary-panel-wrapper ends here-->
